// @ts-ignore
import { type ApiResult } from "@utils/httpClientCore";
import { gaApiCall } from "@utils/httpClientCsrf";
// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { renderJsonWithNumbersAsBigint, parseJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import type * as schema from "@newgenerated/shared/schema";
import { deserialize_BookmarkResponse } from "@newgenerated/shared/serializerDeserializer/BookmarkResponse";

export async function bookmarkOnlineContent(props: { onlineContentId: bigint; bookmarked: boolean }): Promise<ApiResult<schema.BookmarkResponse>> {
  let path = "/gaapi/online-content-ix/{onlineContentId}/bookmark";
  path = path.replace(
    "{onlineContentId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.onlineContentId),
  );
  const urlSearchParams = new URLSearchParams();
  [props.bookmarked].flat().forEach((value) => {
    urlSearchParams.append(
      "bookmarked",
      ((value) => {
        const parsed_again = parseJsonWithNumbersAsBigint(value);
        assert(typeof parsed_again === "boolean");
        return parsed_again ? "true" : "false";
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      ),
    );
  });
  if (urlSearchParams.toString() !== "") {
    path += "?";
    path += urlSearchParams.toString();
  }
  const response = await gaApiCall({ path: path, method: "POST", requestBody: null });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.BookmarkResponse> => {
    return deserialize_BookmarkResponse(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error", errorCode: null, errorMessage: "deserialize failed" };
  }
  return { kind: "success", data: deserialized.value };
}
